import React from 'react';
import type { CreditCardViewProps } from './types/credit-card.types';
import { useCreditCard } from './hooks/useCreditCard';
import CreditCardHeader from './components/CreditCardHeader';
import CreditCardDetails from './components/CreditCardDetails';
import CreditCardNotifications from './components/CreditCardNotifications';

const CreditCardView: React.FC<CreditCardViewProps> = (props) => {
  useCreditCard(props);

  return (
    <div className="container mx-auto p-4 sm:p-6 lg:p-8 max-w-3xl bg-card-bg-light dark:bg-card-bg-dark shadow-xl rounded-lg my-8">
      <CreditCardHeader customerName={props.customerName} />

      <CreditCardDetails
        orderId={props.orderId}
        totalAmount={props.totalAmount}
        paymentMethod={props.paymentMethod}
      />

      <CreditCardNotifications shopifyData={props.shopifyData} />
    </div>
  );
};

export default CreditCardView; 